import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const DropdownListContainer = styled.div`
  z-index: 7;
  position: relative;
  display: flex;
  flex-direction: column;
`;
